import _ from "lodash";
import Moment from "moment";
import arLocale from "moment/locale/ar";
import pluralize from "pluralize";
import * as localStorage from "../lib/localStorage";

const locale = localStorage.getItem("locale");
locale === "ar" && Moment.locale(locale, arLocale);

Moment.locale("en");

export const secondsToHoursAndMinutes = (durationMS) => {
    if (typeof durationMS === undefined || durationMS === null) {
        return null;
    }
    const momentDuration = Moment.duration(durationMS * 1000);

    const days = momentDuration.days();
    const hours = momentDuration.hours();
    const minutes = momentDuration.minutes();
    const seconds = momentDuration.seconds();
    const milliSeconds = momentDuration.milliseconds();
    const months = momentDuration.months();

    const dayStr = days ? `${pluralize("day", days, true)}, ` : "";
    const hourStr = hours ? `${pluralize("hour", hours, true)}, ` : "";
    const minutesStr = minutes ? `${pluralize("minute", minutes, true)}` : "";
    const monthsStr = months ? `${pluralize("months", months, true)}, ` : "";

    return hours === 0 && minutes === 0 && (seconds !== 0 || milliSeconds !== 0)
        ? "less than minute"
        : (monthsStr + dayStr + hourStr + minutesStr).replace(/,(\s+)?$/, "");
};

export const datesToDuration = (start, end) => {
    if (_.isNil(start) || _.isNil(end)) {
        return "N/A";
    }

    const {
        _data: { years, months, days },
    } = Moment.duration(Moment(end).diff(Moment(start)));

    const durationString = years
        ? `${years} Years`
        : months
        ? `${months} Months`
        : days
        ? `${days} Days`
        : "less than day";

    return durationString;
};

export const dateToDay = (date) => Moment(new Date(date)).locale(locale, arLocale).format("dddd");

export const dateToFormattedTime = (dateString) =>
    Moment(dateString).locale(locale, arLocale).format("hh:mm A");

export const dateToDayAndTime = (date) => dateToDay(date) + " " + dateToFormattedTime(date);

export const dateToFormattedFullDate = (date) =>
    Moment(date).locale(locale, arLocale).format("D/M/YYYY");

export const dateToFormattedFullDateAndTime = (date) => {
    if (!date) return "";

    const momentDate = Moment(date);
    if (!momentDate.isValid()) return "";

    return momentDate.locale(locale).format("llll");
};

export const isValidDate = (date) => Moment(date, "YYYY-M-DTH:m:s.SSSZ", true).isValid();

export const dateEnLocale = (date) => Moment(date, Moment.ISO_8601).locale("en").format();
//* from 2023-05-18T10:49:09.980Z to 05/18/2023 3:49AM
export const dateToFullDateAndTime = (date) => Moment(date).local("en").format("MM/DD/YYYY h:mmA");

export const dateToNumberAndMonth = (date) => {
    return Moment(new Date(date)).locale(locale, arLocale).format("D MMM");
};

export const milliSecondsToFormattedTime = (milliSeconds) => {
    const duration = Moment.duration(milliSeconds);
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    return `${hours}:${minutes}:${seconds}`;
};

export const getDuration = (start, end) => {
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    const duration = endTime - startTime;
    return milliSecondsToFormattedTime(duration);
};
